import { render } from "./autoMessage.vue?vue&type=template&id=575b4fae&scoped=true"
import script from "./autoMessage.vue?vue&type=script&lang=js"
export * from "./autoMessage.vue?vue&type=script&lang=js"

import "./autoMessage.vue?vue&type=style&index=0&id=575b4fae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575b4fae"]])

export default __exports__